<app-layout>
  <div class="avd-iframe-container">
    <!-- Tentativa de iframe (será bloqueado, mas tentamos) -->
    <iframe
      *ngIf="!showFallback"
      #avdIframe
      [src]="iframeSrc"
      frameborder="0"
      allowfullscreen
      allow="clipboard-read; clipboard-write; fullscreen"
      class="avd-iframe"
      title="Azure Virtual Desktop"
      (load)="onIframeLoad()"
      (error)="onIframeError()">
    </iframe>

    <!-- Mensagem informativa com botão para abrir em nova janela (fallback) -->
    <div *ngIf="showFallback" class="error-message">
      <div class="error-content">
        <div class="error-icon">🔗</div>
        <h2>Azure Virtual Desktop</h2>
        <p>
          O Azure Virtual Desktop não pode ser exibido diretamente nesta página devido a políticas de segurança do navegador.
        </p>
        <p class="error-subtitle">
          Clique no botão abaixo para abrir em uma nova janela:
        </p>
        <button class="open-button" (click)="openInNewWindow()">
          <span>🔗</span>
          Abrir Azure Virtual Desktop
        </button>
      </div>
    </div>
  </div>
</app-layout>
